import type Swiper from "swiper"
import { type SwiperContainer, register } from "swiper/element"
import type { SwiperOptions } from "swiper/types"

register()
export function initSwiperContainer(container: SwiperContainer, config: SwiperOptions = {}) {
    if (!container) {
        console.warn("init swiper container not found. Container: ", container, "options: ", config)
        return
    }
    const params = {
        // TODO is this really necessary? w3 validator marks spans with an attribute "part='x'" as invalid. To make sure swiper does not render "part='x'" we have to use a custom render function
        pagination: {
            type: "custom",
            renderCustom: (_: Swiper, current: number, total: number) => {
                return Array(total)
                    .fill(0)
                    .map(
                        (_, index) =>
                            `<span ${index + 1 === current ? 'class="swiper-pagination-bullet swiper-pagination-bullet-active" aria-current="true"' : 'class="swiper-pagination-bullet"'}></span>`,
                    )
                    .join("")
            },
        },
        ...config,
    }

    Object.assign(container, params)
    container.initialize()
}
